import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-3a56ddb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "info-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-info",
    src: _imports_0,
    alt: "icon"
  })
], -1))
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "info-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon-info",
    src: _imports_0,
    alt: "icon"
  })
], -1))
const _hoisted_8 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.dataRequest)
          ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
          : (_openBlock(), _createBlock(_component_Form, {
              key: 1,
              as: "el-form",
              onSubmit: _ctx.nextStep
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_select, {
                  modelValue: _ctx.professionValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.professionValue) = $event)),
                  name: "profession",
                  label: _ctx.$localize('registration.step-3.profession.label'),
                  placeholder: _ctx.$localize('registration.step-3.profession.placeholder'),
                  options: _ctx.mainStore.profession,
                  onChange: _ctx.changeProfession
                }, null, 8, ["modelValue", "label", "placeholder", "options", "onChange"]),
                (_ctx.showHippaStorageLable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localize('registration.healthcare.storage.message')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_app_button, {
                  type: "primary",
                  "native-type": "submit",
                  class: "w-100 el-button-lg",
                  disabled: _ctx.professionValue === undefined,
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.provider.button')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.dataRequest)
          ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
          : (_openBlock(), _createBlock(_component_Form, {
              key: 1,
              as: "el-form",
              onSubmit: _ctx.nextStep
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_select, {
                  modelValue: _ctx.professionValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.professionValue) = $event)),
                  name: "profession",
                  label: _ctx.$localize('registration.step-3.profession.label'),
                  placeholder: _ctx.$localize('registration.step-3.profession.placeholder'),
                  options: _ctx.mainStore.profession
                }, null, 8, ["modelValue", "label", "placeholder", "options"]),
                (_ctx.showHippaStorageLable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localize('registration.healthcare.storage.message')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_app_button, {
                  type: "primary",
                  "native-type": "submit",
                  class: "w-100 el-button-lg",
                  disabled: _ctx.professionValue === undefined,
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.button.next')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
      ]))
}